/* Couchpotato — Fabric types page behaviour.
   Sample selection (max N) + sticky bar + limit dialog + swatch modal with the
   product's own media gallery + type-index jump + order to cart/checkout.
   Idempotent and theme-editor aware. No dependencies. */
(function () {
  var ICON_PREV = '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>';
  var ICON_PLAY = '<span class="cp-fp-play"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5z"/></svg></span>';

  function setup(section) {
    if (section.dataset.cpFpReady) return;
    section.dataset.cpFpReady = '1';

    var MAX = parseInt(section.dataset.max, 10) || 5;
    var sel = []; // array of variant ids (string)
    var swatches = [].slice.call(section.querySelectorAll('.cp-fp-swatch'));

    var barThumbs = section.querySelector('[data-cp-fp="barThumbs"]');
    var barCount  = section.querySelector('[data-cp-fp="barCount"]');
    var barHelp   = section.querySelector('[data-cp-fp="barHelp"]');
    var orderBtn  = section.querySelector('[data-cp-fp="order"]');
    var modal     = section.querySelector('[data-cp-fp="modal"]');
    var limit     = section.querySelector('[data-cp-fp="limit"]');
    var limitThumbs = section.querySelector('[data-cp-fp="limitThumbs"]');

    function findSw(v) { for (var i = 0; i < swatches.length; i++) if (swatches[i].dataset.variant === v) return swatches[i]; return null; }
    function label(n) { return n + ' af ' + MAX + ' gratis stofprøver valgt'; }

    function thumbHTML(v) {
      var s = findSw(v); if (!s) return '';
      var n = s.dataset.name;
      return '<div class="cp-fp-th"><img alt="' + esc(n) + '" title="' + esc(n) + '" src="' + s.dataset.img + '"><button type="button" aria-label="Fjern ' + esc(n) + '">&times;</button></div>';
    }
    function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

    function renderBar() {
      if (barThumbs) {
        barThumbs.innerHTML = sel.map(thumbHTML).join('');
        [].slice.call(barThumbs.querySelectorAll('.cp-fp-th button')).forEach(function (b, i) {
          b.addEventListener('click', function () { toggle(sel[i]); });
        });
      }
      if (barCount) barCount.textContent = label(sel.length);
      if (barHelp) barHelp.textContent = sel.length ? 'Gratis, fragten er på os. Leveres på få dage.' : 'Tryk + på et stof for at komme i gang. Prøver og fragt er gratis.';
      if (orderBtn) orderBtn.disabled = sel.length === 0;
    }

    function toggle(v) {
      var i = sel.indexOf(v), s = findSw(v);
      if (i > -1) { sel.splice(i, 1); if (s) s.classList.remove('cp-sel'); }
      else {
        if (sel.length >= MAX) { openLimit(); return; }
        sel.push(v); if (s) s.classList.add('cp-sel');
      }
      renderBar(); syncModalBtn();
    }

    function openLimit() {
      if (!limit) return;
      if (limitThumbs) {
        limitThumbs.innerHTML = sel.map(thumbHTML).join('');
        [].slice.call(limitThumbs.querySelectorAll('.cp-fp-th button')).forEach(function (b, i) {
          b.addEventListener('click', function () { var v = sel[i]; toggle(v); openLimit(); });
        });
      }
      limit.classList.add('cp-open');
    }

    /* ---- swatch events ---- */
    swatches.forEach(function (s) {
      var add = s.querySelector('.cp-fp-add');
      var fig = s.querySelector('.cp-fp-swfig');
      var nm  = s.querySelector('.cp-fp-swname');
      if (add) add.addEventListener('click', function (e) { e.stopPropagation(); toggle(s.dataset.variant); });
      if (fig) fig.addEventListener('click', function () { openModal(s); });
      if (nm)  nm.addEventListener('click', function () { openModal(s); });
    });

    /* ---- modal ---- */
    var mMain = modal && modal.querySelector('[data-cp-fp="mMain"]');
    var mThumbs = modal && modal.querySelector('[data-cp-fp="mThumbs"]');
    var mFam = modal && modal.querySelector('[data-cp-fp="mFam"]');
    var mTag = modal && modal.querySelector('[data-cp-fp="mTag"]');
    var mName = modal && modal.querySelector('[data-cp-fp="mName"]');
    var mBen = modal && modal.querySelector('[data-cp-fp="mBen"]');
    var mSpecs = modal && modal.querySelector('[data-cp-fp="mSpecs"]');
    var mAdd = modal && modal.querySelector('[data-cp-fp="mAdd"]');
    var mFree = modal && modal.querySelector('[data-cp-fp="mFree"]');
    var current = null, media = [], mi = 0;

    function readMedia(s) {
      var tag = s.querySelector('.cp-fp-swmedia');
      var arr = [];
      if (tag) { try { arr = JSON.parse(tag.textContent || '[]'); } catch (e) { arr = []; } }
      if (!arr.length) arr = [{ t: 'image', src: s.dataset.img, alt: s.dataset.name }];
      return arr;
    }
    function renderMain() {
      if (!mMain) return;
      var m = media[mi];
      if (m.t === 'video') {
        mMain.innerHTML = '<video autoplay muted loop playsinline controls preload="auto" ' + (m.poster ? 'poster="' + m.poster + '" ' : '') + 'src="' + m.src + '"></video>';
      } else {
        mMain.innerHTML = '<img alt="' + esc(m.alt || '') + '" src="' + m.src + '">';
      }
    }
    function renderThumbs() {
      if (!mThumbs) return;
      mThumbs.innerHTML = media.map(function (m, i) {
        var img = '<img alt="" src="' + (m.t === 'video' ? (m.poster || m.src) : m.src) + '">';
        return '<button type="button" class="cp-fp-mth' + (i === mi ? ' on' : '') + '" data-i="' + i + '">' + img + (m.t === 'video' ? ICON_PLAY : '') + '</button>';
      }).join('');
      [].slice.call(mThumbs.querySelectorAll('.cp-fp-mth')).forEach(function (b) {
        b.addEventListener('click', function () { mi = parseInt(b.dataset.i, 10); renderMain(); markThumbs(); });
      });
    }
    function markThumbs() {
      if (!mThumbs) return;
      [].slice.call(mThumbs.querySelectorAll('.cp-fp-mth')).forEach(function (b, i) { b.classList.toggle('on', i === mi); });
    }
    function step(dir) { if (!media.length) return; mi = (mi + dir + media.length) % media.length; renderMain(); markThumbs(); }

    function openModal(s) {
      if (!modal) return;
      current = s; media = readMedia(s); mi = 0;
      var fam = s.closest('.cp-fp-family');
      var premium = s.dataset.premium === 'true';
      if (mFam) mFam.textContent = s.dataset.family;
      if (mTag) { mTag.textContent = premium ? 'Prisgruppe 2' : 'Prisgruppe 1'; mTag.className = 'cp-fp-tag' + (premium ? ' cp-fp-tag-prem' : ''); }
      if (mName) mName.textContent = s.dataset.name;
      if (mBen && fam) { var b = fam.querySelector('.cp-fp-benefit'); mBen.textContent = b ? b.textContent : ''; }
      if (mSpecs && fam) {
        mSpecs.innerHTML = '';
        [].slice.call(fam.querySelectorAll('.cp-fp-specs li')).forEach(function (li) { mSpecs.appendChild(li.cloneNode(true)); });
      }
      renderMain(); renderThumbs(); syncModalBtn();
      modal.classList.add('cp-open');
    }
    function syncModalBtn() {
      if (!mAdd || !current) return;
      var on = sel.indexOf(current.dataset.variant) > -1;
      mAdd.textContent = on ? 'Tilføjet - fjern prøve' : 'Tilføj gratis prøve';
      mAdd.classList.toggle('cp-added', on);
      if (mFree) mFree.textContent = (sel.length) + ' af dine ' + MAX + ' gratis prøver';
    }
    if (mAdd) mAdd.addEventListener('click', function () { if (current) toggle(current.dataset.variant); });
    if (modal) [].slice.call(modal.querySelectorAll('.cp-fp-mnav')).forEach(function (b) {
      b.addEventListener('click', function () { step(parseInt(b.dataset.dir, 10)); });
    });

    /* ---- close dialogs ---- */
    [].slice.call(section.querySelectorAll('[data-cp-close]')).forEach(function (el) {
      el.addEventListener('click', function () { var m = el.closest('.cp-fp-modal'); if (m) m.classList.remove('cp-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') [].slice.call(section.querySelectorAll('.cp-fp-modal.cp-open')).forEach(function (m) { m.classList.remove('cp-open'); });
    });

    /* ---- type index jump ---- */
    [].slice.call(section.querySelectorAll('.cp-fp-ix')).forEach(function (p) {
      p.addEventListener('click', function () {
        var id = p.dataset.jump;
        var t = document.getElementById(id);
        if (!t) return;
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        /* replaceState, not location.hash — setting the hash would re-jump and
           cancel the smooth scroll. Leaves the URL shareable either way. */
        if (window.history && history.replaceState) {
          history.replaceState(null, '', '#' + id);
        }
      });
    });

    /* ---- order ---- */
    if (orderBtn) orderBtn.addEventListener('click', function () {
      if (!sel.length) return;
      orderBtn.disabled = true;
      var items = sel.map(function (v) { return { id: parseInt(v, 10), quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { orderBtn.disabled = false; });
    });

    renderBar();
  }

  /* ---- deep links, e.g. /pages/stoftyper#nova -----------------------------
     The browser resolves the hash while the index images above are still
     lazy-loading, so by the time the page settles the target has been pushed
     down and the shopper lands somewhere short of it. Re-align once on boot and
     again on load. Scoped to family sections so no other #hash is hijacked. */
  function gotoHash(behavior) {
    var id = (window.location.hash || '').slice(1);
    if (!id) return;
    var t;
    try { t = document.getElementById(decodeURIComponent(id)); } catch (e) { t = document.getElementById(id); }
    if (t && t.classList.contains('cp-fp-family')) {
      t.scrollIntoView({ behavior: behavior || 'auto', block: 'start' });
    }
  }

  function boot(scope) {
    var list = (scope || document).querySelectorAll('[data-section-type="cp-fabric-types"]');
    [].slice.call(list).forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); gotoHash(); });
  else { boot(document); gotoHash(); }
  window.addEventListener('load', function () { gotoHash(); });
  window.addEventListener('hashchange', function () { gotoHash('smooth'); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
